// © 2015-2021 WDNA - All Rights Reserved
import { combineReducers, Reducer } from 'redux';
import { connectRouter } from 'connected-react-router';
import { History } from 'history';

import layoutReducer from 'wdna-components/lib/layout/reducer';
import navigationReducer from 'wdna-components/lib/navigation/reducer';
import mainFilterReducer from 'wdna-components/lib/mainfilter/reducer';
import sidebarReducer from 'wdna-components/lib/sidebar/reducer';
import schedulerReducer from 'wdna-components/lib/scheduler/reducer';
import tabsReducer from 'wdna-components/lib/tabs/reducer';

import authReducer from '../services/auth/reducer';
import userReducer from '../services/user/reducer';

import keplerReducer from './keplerReducer';

const rootReducer = (history: History): Reducer => {
  return combineReducers({
    auth: authReducer,
    keplerGl: keplerReducer,
    layout: layoutReducer,
    mainFilter: mainFilterReducer,
    navigation: navigationReducer,
    scheduler: schedulerReducer,
    sidebar: sidebarReducer,
    tabs: tabsReducer,
    user: userReducer,
    router: connectRouter(history),
  });
};

export default rootReducer;
